module.exports = __webpack_public_path__ + "img/checkbox_off.b84394bb.svg";